import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgSearchHome = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 0.25C3.49594 0.25 0.25 3.49594 0.25 7.5C0.25 11.5041 3.49594 14.75 7.5 14.75C9.23199 14.75 10.8221 14.1427 12.0691 13.1293L16.4553 17.4981L16.5396 17.5706C16.8335 17.7879 17.2502 17.763 17.516 17.4963C17.8084 17.203 17.8076 16.7281 17.5143 16.4357L13.1297 12.0686C14.1428 10.8218 14.75 9.23179 14.75 7.5C14.75 3.49594 11.5041 0.25 7.5 0.25ZM7.5 1.75C10.6756 1.75 13.25 4.32436 13.25 7.5C13.25 10.6756 10.6756 13.25 7.5 13.25C4.32436 13.25 1.75 10.6756 1.75 7.5C1.75 4.32436 4.32436 1.75 7.5 1.75Z"
      fill="#717376"
    />
  </svg>
);

export default SvgSearchHome;
